import React, {  useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { navdata } from "../../constants/data";
import { clearUserAction } from "../../redux/action/user";
const Navbar = (props) => {
  const { fullname } = useSelector((state) => state.users);
  const [selectednav, setSelectednav] = useState(props.state);
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <div className='w-52 bg-dark-blue h-full hidden md:block'>
      <div className='flex flex-col justify-center items-center font-semibold w-full my-10 text-white'>
        <img
          className='m-2'
          src='/statics/images/person.svg'
          alt='logo'
          onClick={() => {
            // history.goBack();
          }}
        />
        <div>{fullname}</div>
      </div>

      <div className='pr-3'>
        {navdata.map((row) => (
          <div
            key={row.id}
            className={`transition-all my-3 px-3 py-2 flex items-start justify-start gap-2 cursor-pointer ${
              selectednav === row.id
                ? "text-black bg-white rounded-r-xl"
                : "text-white"
            }`}
            onClick={() => {
              setSelectednav(row);
              history.push(row.href);
            }}
          >
            <img
              src={
                selectednav === row.id
                  ? "/statics/images/" + row.img_hover
                  : "/statics/images/" + row.img
              }
              width='20'
              height='20'
              alt='eye'
            />
            <div>{row.title}</div>
          </div>
        ))}
      </div>

      <div
        className='exit my-10 px-3 py-4 flex items-center justify-center gap-2 cursor-pointer absolute bottom-0 rounded-l-2xl text-white'
        onClick={() => {
          dispatch(clearUserAction());
          history.push("/login");
        }}
      >
        <img src='/statics/images/exit.svg' width='16' alt='exit' />
        <div>خروج</div>
      </div>
    </div>
  );
};

export default Navbar;
